import React from 'react';
import styled from 'styled-components';

import { classList } from '@/helpers';

interface ISkeletonBlockProps {
  className?: string;
}

const SkeletonBlock = ({ className }: ISkeletonBlockProps): React.ReactElement => {
  return <Block className={classList(className, 'skeleton-block')} />;
};

export { SkeletonBlock };

const Block = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: #dae5eb;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);

  position: relative;
  overflow: hidden;
  z-index: 1; /* Necessary for overflow: hidden to work correctly in Safari */

  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0) 60%
    );
    transform: translate3d(-100%, 0, 0);

    animation-name: loading-skeleton;
    animation-direction: normal;
    animation-duration: 1.5s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }

  @keyframes loading-skeleton {
    100% {
      transform: translate3d(100%, 0, 0);
    }
  }
`;
